module.exports = __webpack_public_path__ + "static/img/947_phase_function_Paper_PointsHejduk_Prediction.43a5ca7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/947_phase_function_Paper_PointsHejduk_Prediction.png
// module id = mt2A
// module chunks = 0